import React from 'react'
import Section from '../../../components/section'
import Loader from "../../../components/loader";

const PaymentsStatusView = props =>{
    const {isUmStatusApproved, isUmStatusError, mpgUserId} = props
     if(isUmStatusApproved) {
         return (
             <div className="text-center">
<Loader description="We are updating your details. Please be patient."/>

         </div>
         )
    } else if(isUmStatusError) {

        return <>Try Again</>
    } else {
         return <>Try Again</>
     }

}
const PaymentsDetailsView = props => {
    const {isUmStatusApproved} = props
    return (
        <Section>
            <div className="row">
                <div className="col-12 col-md-5 mx-auto">
                    <div className="auth-form-wrapper text-center">
                        <PaymentsStatusView isUmStatusApproved={isUmStatusApproved}/>
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default PaymentsDetailsView